<template>
    <div class="overview">
        <ModuleList />
    </div>
</template>

<script>
export default {
    name: 'Home',
    mounted()
    {
        this.$root.resetHeader('Übersicht');
    }
};
</script>

<style lang="scss" src="./Home.scss" />
